import { Inject, Injectable } from '@angular/core';

import { RidangoEpic, RidangoReduxAction } from '@ridango/core';

import { ActionsObservable } from 'redux-observable';
import { catchError, map, switchMap } from 'rxjs/operators';

import { Authenticator } from '../../services';
import { RecoverPasswordActions } from './recover-password.actions';
import Env from '@ridango/core/env';

@Injectable({
    providedIn: 'root'
})
export class RecoverPasswordEpics implements RidangoEpic {
    constructor(
        private actions: RecoverPasswordActions,
        private auth: Authenticator,
        @Inject('ENV') public env: Env
    ) {}

    register() {
        return [this.recoverPassword, this.resetPassword];
    }

    recoverPassword = (action$: ActionsObservable<any>) =>
        action$.ofType(RecoverPasswordActions.RECOVER_PASSWORD_REQUEST).pipe(
            switchMap((action: RidangoReduxAction) => {
                const { email, locale, callback } = action.payload;

                return this.auth.sendResetEmail(email, locale, callback).pipe(
                    map(() => this.actions.recoverPasswordRequestComplete()),
                    catchError((e) => [this.actions.recoverPasswordRequestFailed(e)])
                );
            })
        );

    resetPassword = (action$: ActionsObservable<any>) =>
        action$.ofType(RecoverPasswordActions.SET_NEW_PASSWORD).pipe(
            switchMap((action: RidangoReduxAction) => {
                const { password, token, locale, ondemandRequest } = action.payload;

                return this.auth.sendNewPassword(password, token, locale).pipe(
                    map((d: any) => {
                        const loginWhenResetPassword = this.env.REGISTRATION?.LOGIN_WHEN_RESET_PASSWORD ?? true;

                        if (loginWhenResetPassword) {
                            return this.actions.setNewPasswordSuccess(d.access_token, ondemandRequest);
                        }

                        return this.actions.setNewPasswordWithoutLoginSuccess();
                    }),
                    catchError((e) => [this.actions.recoverPasswordRequestFailed(e)])
                );
            })
        );
}
